// extracted by mini-css-extract-plugin
export var descriptionControlImage = "transcript-module--description-control-image--6wEvF";
export var transcriptBlockContainer = "transcript-module--transcript-block-container--I+tOP";
export var transcriptBlockContainerVisible = "transcript-module--transcript-block-container--visible--Dx+lJ";
export var transcriptDescription = "transcript-module--transcript-description--ZH+TW";
export var transcriptTitle = "transcript-module--transcript-title--zts0S";
export var transcriptTopLabel = "transcript-module--transcript-top-label--OUxYt";
export var visibilityToggleButton = "transcript-module--visibility-toggle-button--TAv26";